import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ObjectTypes } from '@fi-shared/types';
import { BehaviorSubject } from 'rxjs';
import { BalooSyncTabIndex } from '@fi-app/external-platform-integration/baloo/baloo-sync-log-summary-items.enum';
import { isDefined } from '@fi-shared/utils';
import { BalooService } from '@fi-app/external-platform-integration/baloo/baloo.service';
import { BalooHelperService } from '@fi-app/external-platform-integration/baloo/baloo-helper.service';

interface ISyncLogTab {
    tabLabelId: string;
    objectType: ObjectTypes;
}

@Component({
    selector: 'baloo-sync-log',
    templateUrl: './baloo-sync-log.component.html',
    styleUrls: ['./baloo-sync-log.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'baloo-sync-log' },
    standalone: false,
})
export class BalooSyncLogComponent implements OnInit {
    @Input() selectedTabIndex: number;
    @Input() selectedSyncLogId: number;

    constructor(
        private balooService: BalooService,
        private balooHelperService: BalooHelperService,
    ) {}

    ngOnInit(): void {
        if (isDefined(this.selectedTabIndex)) {
            setTimeout(() => {
                this.selectedTabIndexChange(this.selectedTabIndex);
            }, 100);
        }
        if (isDefined(this.selectedSyncLogId)) {
            // we should load single sync log because currently loaded list can not contain needed item
            this.balooService.getSyncLog(this.selectedSyncLogId).then((syncLog) => {
                this.balooHelperService.openDetailedLogDialog(syncLog);
            });
        }
    }

    readonly syncLogTabs: ISyncLogTab[] = [
        {
            tabLabelId: 'common.units',
            objectType: ObjectTypes.BusinessUnit,
        },
        {
            tabLabelId: 'common.roles',
            objectType: ObjectTypes.Role,
        },
        {
            tabLabelId: 'common.users',
            objectType: ObjectTypes.User,
        },
    ];
    selectedTabIndex$: BehaviorSubject<number> = new BehaviorSubject<number>(0);

    selectedTabIndexChange(newTabIndex: number) {
        this.selectedTabIndex$.next(newTabIndex);
    }

    protected readonly BalooSyncTabIndex = BalooSyncTabIndex;
}
